import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "whitespace-nowrap"
}





export default /*@__PURE__*/_defineComponent({
  __name: 'TRButton',
  props: {
  //default: () => {},
  click: {
    type: Function,
    default: () => {},
  },
  text: {
    type: String,
    default: '',
  },
  icon: {
    type: String,
    default: '',
  },
  iconPosition: {
    type: String,
    default: 'top',
  },
  type: {
    type: String,
    default: 'default',
  },
  selected: {
    type: Boolean,
    default: false,
  },
  padding : {
    type: String,
    default: '2',
  },
},
  setup(__props) {


const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["flex items-center gap-2 hover:bg-trader-blue justify-center rounded pointer text-trader-text text-center hover:text-trader-highlight active:bg-trader-darkest-gray", [
            props.selected ? 'bg-trader-blue text-white' : 'bg-trader-gray',
            props.iconPosition === 'top' ? 'flex-col p-'+props.padding : 'flex-row px-'+__props.padding
          ]]),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (props.click && props.click(...args)))
  }, [
    ((props.iconPosition == 'top' || props.iconPosition == 'left') && props.icon !== '')
      ? (_openBlock(), _createElementBlock("i", {
          key: 0,
          class: _normalizeClass(["text-center", props.icon])
        }, null, 2))
      : _createCommentVNode("", true),
    (props.text !== '')
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(props.text), 1))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})